module.exports = __webpack_public_path__ + "media/images/matchmaking-banner2-dc6170e09ecf574d9bea57adc268b153.webp";